var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleTagManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2470,
    height: 2470,
    viewBox: "0 0 2470 2470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1449.81 2376.05L1021.01 1946.75L1942.11 1016.25L2378.81 1452.85L1449.81 2376.05Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1452.91 527.15L1016.31 90.45L90.5125 1016.25C-30.0875 1136.75 -30.1875 1332.05 90.3125 1452.65C90.4125 1452.75 90.5125 1452.85 90.5125 1452.85L1016.31 2378.65L1444.61 1948.35L745.013 1235.15L1452.91 527.15Z",
    fill: "#5C5C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2378.71 1016.25L1452.91 90.45C1332.31 -30.15 1136.81 -30.15 1016.21 90.45C895.612 211.05 895.612 406.55 1016.21 527.05L1942.51 1452.85C2063.11 1573.45 2258.61 1573.45 2379.11 1452.85C2499.71 1332.25 2499.71 1136.75 2379.11 1016.25H2378.71Z",
    fill: "#737373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.21 2469.95C1400.21 2469.95 1537.21 2332.95 1537.21 2163.95C1537.21 1994.95 1400.21 1857.95 1231.21 1857.95C1062.21 1857.95 925.213 1994.95 925.213 2163.95C925.213 2332.95 1062.21 2469.95 1231.21 2469.95Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTagManager);
export default __webpack_public_path__ + "static/media/google-tag-manager.d55f0bc422ebf4eb51b7d43f97006396.svg";
export { ForwardRef as ReactComponent };